import CustomBooleanField from "./CustomBooleanField";
import CustomDateField from "./CustomDateField";
import CustomMultilineTextField from "./CustomMultilineTextField";
import CustomMultiSelectField from "./CustomMultiSelectField";
import CustomNumberField from "./CustomNumberField";
import CustomSingleSelectField from "./CustomSingleSelectField";
import CustomTextField from "./CustomTextField";
import CustomFileField from "./CustomFileField";
import CustomObjectField from "./CustomObjectField";
import HiddenField from "./HiddenField";
import CustomPrimaryKeyField from "./CustomPrimaryKeyField";
import CustomListField from "./CustomListField";
import CustomPercentageField from "./CustomPercentageField";

export const formComponents = {
  booleanField: {
    Component: CustomBooleanField,
  },
  charField: {
    Component: CustomTextField,
  },
  multilineCharField: {
    Component: CustomMultilineTextField,
  },
  choiceField: {
    Component: CustomSingleSelectField,
  },
  dateField: {
    Component: CustomDateField,
  },
  emailField: {
    Component: CustomTextField,
  },
  fileField: {
    Component: CustomFileField,
  },
  floatField: {
    Component: CustomNumberField,
  },
  imageField: {
    Component: CustomFileField,
  },
  integerField: {
    Component: CustomNumberField,
  },
  link: {
    Component: CustomTextField,
  },
  listField: {
    Component: CustomListField,
  },
  logo: {
    Component: CustomFileField,
  },
  manyRelatedField: {
    Component: CustomMultiSelectField,
  },
  multipleChoiceField: {
    Component: CustomMultiSelectField,
  },
  objectField: {
    Component: CustomObjectField,
  },
  primaryKeyRelatedField: {
    Component: CustomPrimaryKeyField,
  },
  slugField: {
    Component: CustomTextField,
  },
  hiddenField: {
    Component: HiddenField,
  },
  percentageField: {
    Component: CustomPercentageField,
  },
  //default to charField
  default: {
    Component: CustomTextField,
  },
};
